import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './about-dialog.component.html'
})
export class AboutDialogComponent {

  constructor(public dialogRef: MatDialogRef<AboutDialogComponent>) {}
}
